import { ZodError, type z } from 'zod';
import { UnexpectedApiResponseError } from './unexpectedApiResponseError';

export function validate<TType>(schema: z.ZodSchema<TType>, data: unknown) {
  try {
    return schema.parse(data);
  } catch (error) {
    if (error instanceof ZodError) {
      console.log(JSON.stringify(error.issues));
    }
    throw new UnexpectedApiResponseError();
  }
}
